import {actionNameGenerator} from '../../../../utils/commonUtil'
const domainPrefix = "gact";
const grantActivityNameGenerator = actionNameGenerator(domainPrefix);

export const fetchGrantsActivityType = grantActivityNameGenerator('fetchGrantsActivity');
export const singleExchangesType = grantActivityNameGenerator('singleExchanges');
export const setExchangeType = grantActivityNameGenerator('setExchangeType');
export const fetchLazyDataType = grantActivityNameGenerator('fetchLazyData');
//recurring lazy
export const fetchRecurringLazyDataType = grantActivityNameGenerator('fetchRecurringLazyData');
export const resetDataType = grantActivityNameGenerator('resetData');
export const cancelTxnScheduleType = grantActivityNameGenerator('cancelTxnSchedule');
export const startDateMobileType = grantActivityNameGenerator('startDateMobile');
export const endDateMobileType = grantActivityNameGenerator('endDateMobile');
export const fetchGrantDataType = grantActivityNameGenerator('fetchGrantData');
export const selectGAtabType = grantActivityNameGenerator('selectGAtab');
export const setFilteredType = grantActivityNameGenerator('setFiltered');
export const gaRecurringDataType = grantActivityNameGenerator('gaRecurringData');
export const gaAgreementDataType = grantActivityNameGenerator('gaAgreementData');
export const cancelGrantsType = grantActivityNameGenerator('cancelGrants');
export const lazyLoadDataLoaderType = grantActivityNameGenerator('lazyLoadDataLoader');
//recurring grants lazy
export const lazyLoadRecurringDataLoaderType = grantActivityNameGenerator('lazyLoadRecurringDataLoader');
export const lazyLoadDataSuccessGaType = grantActivityNameGenerator('lazyLoadDataSuccessGa');
//recurring grants lazy
export const lazyLoadRecurringDataSuccessGaType = grantActivityNameGenerator('lazyLoadRecurringDataSuccessGa');
export const isLoadingSingleDataType = grantActivityNameGenerator('isLoadingSingleData');
export const gaSingleDataFailureType = grantActivityNameGenerator('gaSingleDataFailure');
export const gaRecurringDataFailureType = grantActivityNameGenerator('gaRecurringDataFailure');
export const gaAgreementsDataFailureType = grantActivityNameGenerator('gaAgreementsDataFailure');
export const cancelGrantsDataFailureType = grantActivityNameGenerator('cancelGrantsDataFailure');
export const lazyLoadDataFailureType = grantActivityNameGenerator('lazyLoadDataFailure');
// recurring grants lazy
export const lazyLoadRecurringDataFailureType = grantActivityNameGenerator('lazyLoadRecurringDataFailure');
export const getGrantDetailsType = grantActivityNameGenerator('getGrantDetails');
export const setAllSIngleGrantsType = grantActivityNameGenerator('setAllSingleGrant');
export const singleGrantsSuccessGaType = grantActivityNameGenerator('singleGrantDataSuccessGa');
export const updateSingleGrantsType = grantActivityNameGenerator('updateSinglGrantsGa');
export const showGaLoaderType = grantActivityNameGenerator('showGaLoader');
export const allSingleGrantsInitiateType = grantActivityNameGenerator('allSingleGrantsInitiate');